export const pageStyles = theme => ({
  root: {
    minHeight: '100vh',
    padding: theme.spacing(4, 0, 6),
    backgroundColor: '#F8FAFC'
  }
})

export const tableStyles = theme => ({
  content: { padding: 0, '&:last-child': { paddingBottom: 0 } },
  inner: { overflowX: 'auto', maxWidth: '100%' },
  // Keep financial columns legible; only the table scrolls on narrow screens.
  table: { minWidth: 1000 },
  toolbar: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: theme.spacing(1),
    '& > *': { maxWidth: '100%' },
    '& .MuiPaper-root': { borderRadius: 10 },
    '& .MuiInputBase-root': { minWidth: 0 }
  }
})

export const headerStyles = theme => ({
  root: { marginBottom: theme.spacing(4) },
  header: { padding: 0 },
  currencyText: { color: theme.palette.text.secondary },
  subheader: { display: 'flex', flexWrap: 'wrap', alignItems: 'baseline', gap: theme.spacing(1.5) },
  buttonsContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: theme.spacing(1),
    [theme.breakpoints.down('xs')]: { width: '100%', '& > *': { width: '100%' } }
  },
  eyebrow: { color: theme.palette.text.secondary }
})
